export const highlightCudaCode = (code: string): string => {
  // Escape HTML to prevent injection
  const escaped = code
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

  // Apply syntax highlighting in order
  return escaped
    // Comments first (grey) - both single and multi-line
    .replace(/(\/\/.*$|\/\*[\s\S]*?\*\/)/gm, '<span class="comment">$1</span>')
    
    // CUDA keywords and language keywords (accent-1)
    .replace(/\b(__device_fct|__device_addr|__device__|__host__|__global__|template|class|if|const|auto|synchronize)\b/g, '<span class="keyword">$1</span>')
    
    // Types (accent-2)
    .replace(/\b(void|uint32_t|Context|TSample|float|int|double)\b/g, '<span class="type">$1</span>')
}